import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {WizardContainerComponent} from './container/wizard-container.component';
import {WizardStepIndicationsComponent} from './components/wizard-step-indications/wizard-step-indications.component';
import {WizardStepConsentUseCasesComponent} from './components/wizard-step-consent-use-cases/wizard-step-consent-use-cases.component';
import {StoreModule} from '@ngrx/store';
import {IndicationReducer} from '../indication/store';
import {WizardStepConsentUseCaseDetailsComponent} from './components/wizard-step-consent-use-case-details/wizard-step-consent-use-case-details.component';
import {CoreModule} from '@core/core.module';
import {SharedModule} from '@shared/shared.module';
import {TranslateModule} from '@ngx-translate/core';
import {WizardLanguageStyleComponent} from './components/wizard-language-style/wizard-language-style.component';
import {WizardPresentationModeComponent} from './components/wizard-presentation-mode/wizard-presentation-mode.component';
import {LevelOfDetailComponent} from './components/wizard-step-consent-use-case-details/level-of-detail/level-of-detail.component';
import {WizardLanguageOptionComponent} from './components/wizard-language-option/wizard-language-option.component';
import {PredefinedUseCasesComponent} from './components/wizard-step-consent-use-cases/predefined-use-cases/predefined-use-cases.component';
import {CustomUseCasesComponent} from './components/wizard-step-consent-use-cases/custom-use-cases/custom-use-cases.component';
import {MatIconModule} from '@angular/material/icon';
import {DisplayConsentModule} from '../display-consent/display-consent.module';
import {WizardReducer} from './store';
import {EffectsModule} from '@ngrx/effects';
import {WizardEffects} from './store/wizard-effects';
import {WelcomeModule} from '../welcome-page/welcome.module';
import {A11yModule} from '@angular/cdk/a11y';

const routes: Routes = [
    {
        path: 'wizard', component: WizardContainerComponent
    },
    {
        path: 'step-indications', component: WizardStepIndicationsComponent
    }
];

@NgModule({
    declarations: [
        WizardStepIndicationsComponent,
        WizardStepConsentUseCasesComponent,
        WizardContainerComponent,
        WizardStepConsentUseCaseDetailsComponent,
        WizardLanguageStyleComponent,
        WizardPresentationModeComponent,
        WizardLanguageOptionComponent,
        LevelOfDetailComponent,
        PredefinedUseCasesComponent,
        CustomUseCasesComponent
    ],
    exports: [
        WizardContainerComponent,
        WizardStepIndicationsComponent
    ],
    imports: [
        StoreModule.forFeature(IndicationReducer.REDUCER_NAME, IndicationReducer.indicationReducer),
        StoreModule.forFeature(WizardReducer.REDUCER_NAME, WizardReducer.wizardReducer),
        EffectsModule.forFeature([WizardEffects]),
        RouterModule.forChild(routes),
        CommonModule,
        CoreModule,
        SharedModule,
        TranslateModule,
        MatIconModule,
        DisplayConsentModule,
        WelcomeModule,
        A11yModule
    ]
})
export class WizardModule {
}
